import {
  propertyDetailsTypes,
  assetManagerDetailTypes,
  additionalDetailTypeMap,
} from "./Constant";

const assetManagerKeyToType = Object.fromEntries(
  Object.entries(assetManagerDetailTypes).map(([rowType, objKey]) => [
    objKey,
    rowType,
  ])
) as Record<string, string>;


export const mapPropertyRecordToOptionalDetails = (
  record: any,
  
  siblingSource: any = record
): Array<{ type: string; description: string }> => {
  if (!record) return [];

  const toDescription = (value: any) =>
    value === null || value === undefined ? "" : String(value);

  const rowsByType: Record<string, string> = {};

  // Flat top-level keys (accountNumber, yearBuilt, obligor, loanBalance, ...).
  propertyDetailsTypes.forEach((type) => {
    if (
      type.value in assetManagerDetailTypes ||
      type.value in additionalDetailTypeMap
    ) {
      return; // handled via nested/sibling structures below
    }
    if (type.value in record) {
      rowsByType[type.value] = toDescription(record[type.value]);
    }
  });

  
  const assetManager =
    (record.assetManager && typeof record.assetManager === "object"
      ? record.assetManager
      : null) ||
    (siblingSource?.propertyRecordAssetManager &&
    typeof siblingSource.propertyRecordAssetManager === "object"
      ? siblingSource.propertyRecordAssetManager
      : null);
  if (assetManager) {
    Object.entries(assetManager).forEach(([objKey, value]) => {
      const rowType = assetManagerKeyToType[objKey];
      if (rowType) {
        rowsByType[rowType] = toDescription(value);
      }
    });
  }


  const additionalDetails = Array.isArray(record.additionalDetails)
    ? record.additionalDetails
    : Array.isArray(siblingSource?.propertyRecordAdditionalDetails)
    ? siblingSource.propertyRecordAdditionalDetails
    : null;
  if (additionalDetails) {
    additionalDetails.forEach((detail: any) => {
      if (!detail) return;
      const prefix =
        detail.type === "OperationsAndMaintenance"
          ? "operationsAndMaintenance"
          : detail.type === "Repair"
          ? "repair"
          : null;
      if (prefix && detail.index != null) {
        rowsByType[`${prefix}${detail.index}`] = toDescription(detail.value);
      }
    });
  }

  // Emit rows ordered by propertyDetailsTypes, dropping empty descriptions.
  return propertyDetailsTypes
    .filter((type) => type.value in rowsByType && rowsByType[type.value] !== "")
    .map((type) => ({ type: type.value, description: rowsByType[type.value] }));
};
